import { Dialog, DialogContent, Grid, Typography, Divider } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { PopupTransition } from 'components/@extended/Transitions';
import { CloseCircle } from 'iconsax-react';
import PlaceOrderCard from 'pages/users/components/PlaceOrderCard';
import { useState } from 'react';
import { Limit } from 'types/custom/common';
import { IStock } from 'types/custom/stock';
import { Tick } from 'types/custom/websocket';
import { getActiveUsersCountFromSelected } from 'utils/custom';

interface Props {
  open: boolean;
  handleClose: (status: boolean) => void;
  selectedStock: IStock | null;
  setSelectedStock: (val: IStock | null) => void;
  numberOfStocks: number | string;
  setNumberOfStocks: (val: number | string) => void;
  selectedUsers: Record<string, any>[] | null;
  setNoUsersActive: (val: boolean) => void;
}

export default function PlaceOrderModal({
  open,
  handleClose,
  numberOfStocks,
  selectedStock,
  selectedUsers,
  setNoUsersActive,
  setNumberOfStocks,
  setSelectedStock
}: Props) {
  const [formik, setFormik] = useState<any>(null);
  const [limit, setLimit] = useState<Limit | null>(null);
  const [currentTick, setCurrentTick] = useState<Tick | null>(null);
  const totalLoggedInUsers = getActiveUsersCountFromSelected(selectedUsers ?? []);
  const handleCloseModal = () => {
    if (formik) {
      formik.resetForm();
      setSelectedStock(null);
      setLimit(null);
      setCurrentTick(null);
    }
    handleClose(false);
  };

  const handleCloseWithoutClearForm = () => {
    handleClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="md"
      aria-labelledby="place-order-confirmation-title"
      aria-describedby="place-order-confirmation-description"
    >
      <Grid
        container
        spacing={0}
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: '1px solid {theme.palette.divider}', p: 2, ml: 1 }}
      >
        <Typography variant="h4">Place Manual Order</Typography>
        <IconButton color="secondary" onClick={handleCloseModal}>
          <CloseCircle />
        </IconButton>
        <Grid container spacing={2} justifyContent={'space-between'}></Grid>
      </Grid>
      <Divider />
      <DialogContent sx={{ m: 0, p: 2.5, py: 3 }}>
        <PlaceOrderCard
          selectedStock={selectedStock}
          setSelectedStock={setSelectedStock}
          numberOfStocks={numberOfStocks}
          setNumberOfStocks={setNumberOfStocks}
          selectedUsers={selectedUsers}
          setNoUsersActive={setNoUsersActive}
          handleCloseModal={handleCloseWithoutClearForm}
          setFormik={setFormik}
          currentTick={currentTick}
          setCurrentTick={setCurrentTick}
          limit={limit}
          setLimit={setLimit}
          totalLoggedInUsers={totalLoggedInUsers}
        />
      </DialogContent>
    </Dialog>
  );
}
